import styled from 'styled-components';

interface StyleProps {
    margin?: string;
}

export const HideText = styled.span`
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
    font-size: 1px;
    line-height: 0;
    clip: rect(0 0 0 0);
    white-space: nowrap;
    margin: -1px;
    padding: 0;
    border: 0;
`;

export const PageTitleArea = styled.div`
    padding-top: 10.8125rem;
    width: 100%;
    text-align: center;
`;
export const PageTitle = styled.div`
    position: relative;
    margin-bottom: 38px;
    margin-bottom: 2.375rem;
    h2 {
        font-size: 3.375rem;
        font-family: 'SDGothicNeobTTF-dMd';
        font-weight: bold;
    }
`;

export const PageTitleEx = styled.p`
    color: #999;
    font-size: 1.25rem;
    font-family: 'SDGothicNeobTTF-dMd';
    margin-top: ${(props: StyleProps) => (`${props.margin}` ? props.margin : '')};
`;
